// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f46c2607","977":"3a9f3db0"}[chunkId] + ".chunk.js";
};